<div *ngIf="isUpdated" class="d-flex justify-content-center my-3">
  <button class="btn btn-primary" type="submit" [disabled]="!isUpdated" (click)="showData()">
    {{ 'Sellers.Products.UpdateReport' | translate }}
  </button>
</div>

<app-base-report *ngIf="filterField.length"
                  [filterFields]="filterField"
                  [hasDateRangeFilter]="true"
                  [hasCheckboxes]="false"
                  [reportName]="reportName"
                  [defaultColumns]="tableColumns"
                  [columnsDisplayNames]="displayTableColumns"
                  [data]="qassatlyRepaymentReportData"
                  [rowsLength]="totalNumberOfRecords"
                  (filterTrigger)="filter($event)"
                  (paginationChange)="paginate($event)"
                  (searchChange)="searchChance($event)"
                  [tableLoading]="loading"
                  [hasSort]="true"
                  [emptyDataMessage]="emptyDataMessage"
                  (sortTrigger)="sortChange($event)"
                  [serviceInstance]="qassatlyRepaymentReportService"></app-base-report>

